import axios from 'axios'
import qs from 'qs'
import { Toast } from 'vant';
import store from '../store'
import router from '../router'
import Vue from 'vue'
import md5 from 'js-md5';
import {backstageUrl, cdrAnllysisUrl, isDev, ucBackstageUrl} from '../config/project-config'
const backendPath = backstageUrl,	//后台请求地址
// const ucBackstageUrl = ucBackstageUrl;//userCenter后台请求地址
maxRequest = 0,		//限制当前请求的错误次数

headersConfig = (crossType) => {			//请求头配置
  if (!crossType) {
    return {
      // 这里就是配置一些请求的参数值
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      'Access-Control-Allow-Origin': '*',
      'token': store.getters.getToken,
      'crossType': '0'
    }
  } else {
    let timestamp = new Date().getTime() + '';
    let radom = Math.random() + '';
    var str = timestamp + radom + crossType
    let token = md5(str)
    return {
      // 这里就是配置一些请求的参数值
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      'Access-Control-Allow-Origin': '*',
      'timestamp': timestamp,
      'radom': radom,
      'crossType': crossType,
      'token': store.getters.getToken,
      'crossToken': token
    }
  }
},
openDebug = isDev,			//是否开始debug
debugOrder = [],			//请求后台的记录

debug = (params) => {		//请求后台的记录进行存储

  if (!openDebug) return false		//是否开始了记录存储
  // 如果有参数 就进行存储
  if (params) {
    debugOrder.push({
      ...params,		//请求的信息 以及回馈值
      headers: {		//请求头的信息
        ...headersConfig(0),
      },
      time: new Date().getTime(),		//请求的时间
    })
  }

  return debugOrder  //返回所有的请求记录
}

/**
 * 请求拦截器
 */
axios.interceptors.request.use(
  config => {
    Vue.$vux.loading.show({
        text: '加载中...'
    })
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = store.state.token;
    // token && (config.headers.Authorization = token);
    return config;
  }, error => {
    setTimeout(() => {
        Vue.$vux.loading.hide();
        Toast({
          message: '加载超时',
          duration: 2000,
          forbidClick: true
        });
    }, 3000);
    return Promise.reject(error);
  }
)

/**
 * 响应拦截器
 */
axios.interceptors.response.use(
  response => {
      // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
      // 否则的话抛出错误
      Vue.$vux.loading.hide();
      if (response.status === 200) {
          return Promise.resolve(response);
      } else {
          return Promise.reject(response);
      }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
      Vue.$vux.loading.hide();
      if (error.response.status) {
          switch (error.response.status) {
              // 401: 未登录
              // 未登录则跳转登录页面，并携带当前页面的路径
              // 在登录成功后返回当前页面，这一步需要在登录页操作。
              // case 401:
              //     store.commit("logout")
              //     router.replace({
              //         path: '/login',
              //         query: {
              //             redirect: router.currentRoute.fullPath
              //         }
              //     });
              //     break;

              // 403 token过期
              // 登录过期对用户进行提示
              // 清除本地token和清空vuex中token对象
              // 跳转登录页面
              // case 403:
              //     Toast({
              //         message: '登录过期，请重新登录',
              //         duration: 2000,
              //         forbidClick: true
              //     });
              //     // 清除登录信息
              //     store.commit("logout")
              //     // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
              //     setTimeout(() => {
              //         router.replace({
              //             path: '/login',
              //             query: {
              //                 redirect: router.currentRoute.fullPath
              //             }
              //         });
              //     }, 1000);
              //     break;

              // 404请求不存在
              case 404:
                  Toast({
                      message: '网络请求不存在',
                      duration: 2000,
                      forbidClick: true
                  });
                  break;
              // 其他错误，直接抛出错误提示
              default:
                  let message = error.response.data.message !== undefined ? error.response.data.message : error.response.data;
                  if (openDebug){
                    Toast({
                      message: message,
                      duration: 2000,
                      forbidClick: true
                    });
                  }else{
                    Toast({
                      message: "服务器请求异常",
                      duration: 2000,
                      forbidClick: true
                    });
                  }
          }
          return Promise.reject(error.response);
      }
  }
)

/**
 GET请求
 */
async function requestByGet (url, params, num = 0, type= 0, crossType = 0) {
  if (!url) {
    return {
      code: 0,
      msg: 'haven\'t request url'
    }
  }
  let isRequestError = false,		// 是否请求失败
    errorMsg = ''					//请求的错误信息

  const urlParams = new URLSearchParams()
  for (let i in params) urlParams.append(i, params[i])

  const result = await axios.get(jointUrl(`${url}`), getParam(params, type), {
    headers: {
      ...headersConfig(crossType),
    }
  }).catch(error => {
    /** 当请求出现错误，就会执行 */
    isRequestError = !isRequestError
    errorMsg = error
  })

  if (isRequestError) {			// 判断是否出现错误的请求
    // 判断错误次数是否在允许的范围内
    if (num < maxRequest) {
      return await requestByGet(url, params, num + 1)
    } else {	// 超出了错误次数的范围内 将错误的信息进行返回出去
      return {
        code: 0,
        msg: errorMsg,
      }
    }
  }

  debug({
    method: 'GET',
    url: `${backendPath}/${url}`,
    params,
    result,
  })

  return result			// 返回最终的结果
}

/**
 POST请求
 */
async function requestByPost (url, params, num = 0, type= 0, crossType = 0) {
  if (!url) {
    return {
      code: 0,
      msg: 'haven\'t request url'
    }
  }

  let isRequestError = false,		// 是否请求失败
    errorMsg = ''					//请求的错误信息

  const result = await axios.post(jointUrl(`${url}`), getParam(params, type), {
      headers: {
        ...headersConfig(crossType),
      }
    }
  ).catch(error => {
    /** 当请求出现错误，就会执行 */
    isRequestError = !isRequestError
    errorMsg = error
  })

  if (isRequestError) {			// 判断是否出现错误的请求
    // 判断错误次数是否在允许的范围内
    if (num < maxRequest) {
      return await requestByPost(url, params, num + 1)
    } else {	// 超出了错误次数的范围内 将错误的信息进行返回出去
      return {
        code: 0,
        msg: errorMsg,
      }
    }
  }

  debug({
    method: 'POST',
    url: `${backendPath}/${url}`,
    params,
    result,
  })

  return result			// 返回最终的结果
}

async function requestUploadFiles (url, params, num = 0) {
  if (!url) {
    return {
      code: 0,
      msg: 'haven\'t request url'
    }
  }

  let isRequestError = false,		// 是否请求失败
    errorMsg = ''					//请求的错误信息

  const result = await axios.post(jointUrl(`${url}`), params, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
        'accessToken': store.getters.getToken
      }
    }
  ).catch(error => {
    /** 当请求出现错误，就会执行 */
    isRequestError = !isRequestError
    errorMsg = error
  })

  if (isRequestError) {			// 判断是否出现错误的请求
    // 判断错误次数是否在允许的范围内
    if (num < maxRequest) {
      return await requestUploadFiles(url, params, num + 1)
    } else {	// 超出了错误次数的范围内 将错误的信息进行返回出去
      return {
        code: 0,
        msg: errorMsg,
      }
    }
  }

  debug({
    method: 'POST',
    url: `${backendPath}/${url}`,
    params,
    result,
  })

  return result;
}

/**
 POST请求
 */
async function requestCdrByPost (url, params, num = 0, type = 0, crossType = 0) {

  if (!url) {
    return {
      code: 0,
      msg: 'haven\'t request url'
    }
  }

  let isRequestError = false,		// 是否请求失败
    errorMsg = ''					//请求的错误信息

  const result = await axios.post(jointUrlCdr(`${url}`), getParamCdr(params, type), {
      headers: {
        ...headersConfig(crossType),
      }
    }
  ).catch(error => {
    /** 当请求出现错误，就会执行 */
    isRequestError = !isRequestError
    errorMsg = error
  })

  if (isRequestError) {			// 判断是否出现错误的请求
    // 判断错误次数是否在允许的范围内
    if (num < maxRequest) {
      return await requestCdrByPost(url, params, num + 1)
    } else {	// 超出了错误次数的范围内 将错误的信息进行返回出去
      return {
        code: 0,
        msg: errorMsg,
      }
    }
  }

  debug({
    method: 'POST',
    url: `${cdrAnllysisUrl}/${url}`,
    params,
    result,
  })

  return result			// 返回最终的结果
}

/**
 * 获取请求参数
 */
function getParam (param, type) {
  if (type === null || type === undefined) {
    type = 0;
  }
  if (type == 0) {
    var paramObj = {};
    paramObj.platId = store.getters.getPlatId;
    if(param != null && "" != param) {
      paramObj.in = param;
    }
    return qs.stringify(paramObj);
  } else {
    param.platId = store.getters.getPlatId;
    return qs.stringify(param);
  }
}

/**
 * 获取请求参数
 */
function getParamCdr (param, type) {
  if (type === null || type === undefined) {
    type = 0;
  }
  if (type == 0) {
    var paramObj = {};
    paramObj.platId = store.getters.getPlatId;
    if(param != null && "" != param) {
      paramObj.inStr = param;
    }
    return qs.stringify(paramObj);
  } else {
    param.platId = store.getters.getPlatId;
    return qs.stringify(param);
  }
}

/**
 * 正则表达式校验，判断地址是否是正常的请求地址，如果是正常调用 如果不不是拼接接口前缀
 */
function jointUrl (url) {
  var regUrl = /http[s]{0,1}:\/\/*/;
  if(regUrl.test(url)){
    return url;
  }else{
    var baseuri = backendPath;
    if(url.indexOf("server-usercenter") > -1 && `${ucBackstageUrl}` != null && `${ucBackstageUrl}` != ""){
      //说明是要调用userCenter 的后台
      baseuri = ucBackstageUrl
    }
    if(baseuri.substr(baseuri.length-1,1) !='/'){
      baseuri += '/'
    }
    return `${baseuri}${url}`
  }
}

/**
 * 正则表达式校验，判断地址是否是正常的请求地址，如果是正常调用 如果不不是拼接接口前缀
 */
function jointUrlCdr (url) {
  var regUrl = /http[s]{0,1}:\/\/*/;
  if(regUrl.test(url)){
    return url;
  }else{
    return `${cdrAnllysisUrl}${url}`;
  }
}

export {
  requestByGet, requestByPost, requestUploadFiles, requestCdrByPost
}



// WEBPACK FOOTER //
// ./src/util/request.js